import styled from '@emotion/styled';
import {breakpoints, fonts} from '../styles/vars';
import {at, resetFormElementStyles} from '../styles/utils';

export const DropDown = styled.nav`
  position: relative;
`;

export const DropDownToggle = styled.button`
  ${resetFormElementStyles}
  display: flex;
  align-items: center;
  font-family: ${({primary}) => (primary ? fonts.bold : fonts.regular)};
  font-size: 1.2em;
  line-height: 1em;
  text-transform: capitalize;
  text-align: left;
  outline: none;
  cursor: pointer;
  transition: background 0.2s linear;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 0.5em 0.25em 0.35em 0.5em;
  .icon {
    font-size: 1.5em;
    margin-left: 10px;
  }
  [lang='ar'] & {
    padding: 0.5em 0.5em 0.35em 0.25em;
  }
`;

export const Menu = styled.div`
  opacity: ${({opened}) => {
    return opened ? '1' : '0';
  }};
  visibility: ${({opened}) => (opened ? 'visible' : 'hidden')};
  height: ${({opened}) => (opened ? 'auto' : '0px')};
  overflow: hidden;
  display: ${({opened}) => (opened ? 'block' : 'none')};
  transition: 0.2s linear;
  margin-top: ${({opened}) => (opened ? '1em' : '0')};
  ${at(breakpoints.laptop)} {
    padding-left: 0.5em;
  }
`;

export const FloatingMenu = styled.div`
  position: absolute;
  top: 2em;
  transform: ${({opened}) =>
    opened ? 'translateY(100%)' : 'translateY(-100%)'};
  opacity: ${({opened}) => {
    return opened ? '1' : '0';
  }};
  visibility: ${({opened}) => (opened ? 'visible' : 'hidden')};
  transition: 0.2s linear;
  left: 0;

  [lang='ar'] & {
    top: 4em;
    right: 0;
    left: auto;
  }
`;
